module.exports = __webpack_public_path__ + "img/26-grand-wagoneer.4d9aed51.jpg";